import { render, staticRenderFns } from "./marqueeWrapper.vue?vue&type=template&id=e5739480"
import script from "./marqueeWrapper.vue?vue&type=script&lang=js"
export * from "./marqueeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports